<div class="buying-window--select">
  @if (orderWindows.length > 1) {
    <ng-container
      *ngTemplateOutlet="mobile ? mobileView : desktopView"
    ></ng-container>
  } @else {
    <p class="uppercase">No buying windows are available</p>
  }
</div>

<ng-template #desktopView>
  @if (!hideTitle) {
    <h3>choose window</h3>
    <p class="font-5 uppercase">
      shop current buying window or view past buying windows
    </p>
  }
  <ng-select
    id="order-window-select-desktop"
    class="order-window-select"
    [items]="orderWindows"
    bindLabel="label"
    bindValue="id"
    [searchable]="false"
    [clearable]="false"
    (change)="onChangeOrderWindow($event)"
    name="order"
    placeholder="Please select Buying Window"
    [(ngModel)]="selectedOrderWindowId"
  >
    <ng-template ng-label-tmp let-item="item">
      <span [innerHTML]="formattedLabel(item) | safeContent"></span>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      <span [innerHTML]="formattedLabel(item) | safeContent"></span>
    </ng-template>
  </ng-select>
</ng-template>

<ng-template #mobileView>
  @if (!hideTitle) {
    <h3 class="text-capitalize">choose window</h3>
    <p class="font-6 uppercase">
      shop current buying window or view past buying windows
    </p>
  }
  <ng-select
    id="order-window-select-mobile"
    class="order-window-select mobile"
    [items]="orderWindows"
    bindLabel="label"
    bindValue="id"
    [searchable]="false"
    [clearable]="false"
    (change)="onChangeOrderWindow($event)"
    name="order"
    placeholder="Please select Buying Window"
    [(ngModel)]="selectedOrderWindowId"
  >
    <ng-template ng-label-tmp let-item="item">
      <span
        class="d-block fw-bold"
        [innerHTML]="item.label | safeContent"
      ></span>
      <span
        class="fw-bold"
        [ngClass]="{ 'color-green': item.active, 'color-red': !item.active }"
        >{{ formattedDates(item) }}</span
      >
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      <span
        class="d-block fw-bold"
        [innerHTML]="item.label | safeContent"
      ></span>
      <span
        class="d-block fw-bold"
        [ngClass]="{ 'color-green': item.active, 'color-red': !item.active }"
        >{{ formattedDates(item) }}</span
      >
    </ng-template>
  </ng-select>
</ng-template>
